(function authModuleDefinition() {
    angular.module("Auth", ['Config', 'Storage', 'ngCookies', 'RESTUrlBuilder']);
})();
